import { validateAndTrackEntryPagesEvent } from '@vp/entry-pages-tracking-helpers'
import { FragmentLogger } from '@vp/ubik-logging'

type LinkClickHandler = (event: React.MouseEvent<Element, MouseEvent>) => void

export interface TrackingLinkConfig {
  eventName: string
  pageZone?: number
  properties: {
    category: string
    label: string
    eventDetail: string
    navigationDetail: string
    product_id?: string
    core_product_id?: string
    experimentId?: string
    experimentName?: string
    variationId?: string
    variationName?: string
  }
  linkAttributes: {
    'data-section': string
    'data-position': number | string
    'data-translation': string
  }
}

const DELAY_BEFORE_NAVIGATING_IN_MS = 300

const schema = {
  type: 'object',
  properties: {
    category: {
      type: 'string',
      enum: ['Home Page'],
    },
    label: {
      type: 'string',
      pattern: '^Content:Slim Banner Section$',
    },
    eventDetail: {
      type: 'string',
      pattern: '^/[^;]*;/[^;]*;[^;]*;[^;]*$',
    },
    navigationDetail: {
      type: 'string',
      pattern: '^.*$',
    },
  },
  required: ['category', 'label', 'eventDetail', 'navigationDetail'],
  additionalProperties: false,
}

const createOnClickTrackingHandler = (
  trackingConfig: TrackingLinkConfig | undefined,
  logger: FragmentLogger,
  href?: string,
  openLinkNewTab?: boolean,
  callback?: () => void,
): LinkClickHandler | undefined => {
  if (!trackingConfig) {
    return undefined
  }
  return (event) => {
    event.stopPropagation()
    stopNavigation(event)
    validateAndTrackEntryPagesEvent(trackingConfig.eventName, trackingConfig.properties, schema, logger)

    if (href) {
      setTimeout(() => navigate(href, openLinkNewTab), DELAY_BEFORE_NAVIGATING_IN_MS)
    }

    if (callback) {
      setTimeout(callback, DELAY_BEFORE_NAVIGATING_IN_MS)
    }
  }
}

const navigate = (href: string, openLinkNewTab?: boolean): void => {
  if (!openLinkNewTab) {
    window.location.href = href
  } else {
    window.open(href, '_blank')
  }
}
const stopNavigation = (event: React.MouseEvent<Element, MouseEvent>): void => event.preventDefault()

export { createOnClickTrackingHandler }
